<div class="ya-calendar" [class.mode-ticket]="mode === 'ticket'" [class.mode-default]="mode === 'default'">
  <div class="calendar-container">
    <!-- Day View -->
    <div class="calendar-view" *ngIf="currentView === CalendarView.Day">
      <div class="calendar-header">
        <button a11y_Button class="nav-btn" [class.grayed-out]="isPrevMonthGrayedOut" [disabled]="!canNavigatePrevMonth"
          (click)="previousMonth()" [attr.aria-label]="previousMonthAriaLabel">
          <div class="inline-icon arrow-previews" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
        </button>
        <div a11y_Button class="header-title" (click)="showMonthView()" [attr.aria-label]="getHeaderAriaLabel()">
          {{ currentMonthName }} {{ displayYear }}
        </div>
        <button a11y_Button class="nav-btn" [class.grayed-out]="isNextMonthGrayedOut" [disabled]="!canNavigateNextMonth"
          (click)="nextMonth()" [attr.aria-label]="nextMonthAriaLabel">
          <div class="inline-icon arrow-next" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
        </button>
      </div>
      <div class="calendar-body">
        <div class="weekdays">
          <div class="weekday" *ngFor="let day of weekDays; let i = index" [attr.aria-label]="weekDaysFull[i]">
            <span aria-hidden="true">{{ day }}</span>
          </div>
        </div>
        <div class="days-grid">
          <ng-container *ngFor="let day of calendarDays">
            <div *ngIf="day === null" class="day-cell empty"></div>
            <div *ngIf="day !== null" a11y_Button class="day-cell" [class.not-current-month]="!day.isCurrentMonth"
              [class.past]="day.isPast" [class.today]="day.isToday" [class.has-content]="day.hasContentForTheDay"
              [class.selected]="day.isSelected" [class.disabled]="!day.isCurrentMonth"
              [attr.aria-label]="getDayAriaLabel(day)" [attr.aria-selected]="day.isSelected"
              [attr.aria-current]="day.isToday ? 'date' : null" (click)="onDayClick(day)">
              <span aria-hidden="true">{{ day.dayNumber }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Month View -->
    <div class="calendar-view" *ngIf="currentView === CalendarView.Month">
      <div class="calendar-header">
        <button a11y_Button class="nav-btn" [disabled]="displayYear <= minYear" (click)=" previousYear()"
          [attr.aria-label]="previousYearAriaLabel">
          <div class="inline-icon arrow-previews" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
        </button>
        <div a11y_Button class="header-title" (click)="showYearView()" [attr.aria-label]="getYearHeaderAriaLabel()">
          {{ displayYear }}
        </div>
        <button a11y_Button class="nav-btn" [disabled]="displayYear >= maxYear" (click)="nextYear()"
          [attr.aria-label]="nextYearAriaLabel">
          <div class="inline-icon arrow-next" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
        </button>
      </div>
      <div class="calendar-body">
        <div class="months-grid">
          <div *ngFor="let month of months; let i = index" class="month-cell" a11y_Button
            [class.selected]="i === displayMonth"
            [class.current-month]="i === currentDate.getMonth() && displayYear === currentDate.getFullYear()"
            [class.past]="isMonthPast(i)" [class.disabled]="!hasMonthContent(i)" [attr.aria-label]="months[i]"
            (click)="selectMonth(i)">
            <span aria-hidden="true">{{ getMonthShortName(i) }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Year View -->
    <div class="calendar-view" *ngIf="currentView === CalendarView.Year">
      <div class="calendar-header">
        <button a11y_Button class="nav-btn" [disabled]="!canNavigatePrevYearInYearView"
          (click)="canNavigatePrevYearInYearView && previousYearInYearView()" [attr.aria-label]="previousYearAriaLabel">
          <div class="inline-icon arrow-previews" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
        </button>
        <div a11y_Button class="header-title" (click)="showMonthView()" [attr.aria-label]="getYearHeaderAriaLabel()">
          {{ displayYear }}
        </div>
        <button a11y_Button class="nav-btn" [disabled]="!canNavigateNextYearInYearView"
          (click)="canNavigateNextYearInYearView && nextYearInYearView()" [attr.aria-label]="nextYearAriaLabel">
          <div class="inline-icon arrow-next" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
        </button>
      </div>
      <div class="calendar-body">
        <div class="years-grid" [class.years-grid--single-year]="yearRange.length===1">
          <div *ngFor="let year of yearRange" class="year-cell" a11y_Button [class.selected]="year === displayYear"
            [class.current-year]="year === currentDate.getFullYear()" [class.past]="isYearPast(year)"
            [attr.aria-label]="getYearAriaLabel(year)" [attr.aria-selected]="year === displayYear"
            [attr.aria-current]="year === currentDate.getFullYear() ? 'date' : null" (click)="selectYear(year)">
            <span aria-hidden="true">{{ year }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>